import React, { useEffect, useRef, useState } from 'react';
import "./styles.css";
/**
 * @function UITextInput 
 * @param {STRING} className - Additional CSS class that we can pass to the UITextInput component.
 * @param {STRING} value - Pass the default value to the UITextInput component.
 * @param {STRING} placeHolder - Pass the placeHolder value to the UITextInput component.
 * @param {React.Component} children - React components that's being wrapped by the UITextInput component.
 * @returns {React.Component}
 * @example
 * <UITextInput className="some-class" value="Some value" placeHolder="Some value">
 *  <UIButton className="primary-button">Button name</UIButton>
 * </UITextInput>
 */
export default function UITextInput(props) {
  const className = props.className ?? "";
  const dataPoint = props.dataPoint ? { "data-point" : props.dataPoint } : {};
  const type = props.type ?? "text";
  const maxLength = props.maxLength ?? 999;
  const inputField = useRef();
  const ignoreToggle = { ignoretoggle : props.ignoreToggle ? "true" : "false" };

  const [ state, setState ] = useState(props.value ?? "");

  const onChange = evt => {
    setState(inputField.current.value);

    if(props.onChange instanceof Function) {
      props.onChange(inputField.current.value, evt, inputField.current);
    }
  };

  useEffect(() => setState(props.value ?? ""), [ props.value ]);

  return(
    <div className={`form-row flex-height uitextinput ${className}`}>
      <div className="floating-label-input-container">
        <input className="floating-label-input form-row-input" maxLength={ maxLength } ref={ inputField }
        type={ type } placeholder=" " value={ state } onChange={ onChange } { ...dataPoint } { ...ignoreToggle }></input>
        <label className="floating-label form-row-label">{props.placeHolder}</label>
      </div>
      <span className="form-row-info-text gray-text">
        {props.children}
      </span>
    </div>
  );
}